import { openDB } from 'idb';
import type { IDBRecordAPI } from '@ascend/applock';

const DB_NAME = 'allergen-lens-db';
const DB_VERSION = 1;

let idbAdapter: IDBRecordAPI | null = null;

export function setIDBAdapter(adapter: IDBRecordAPI): void {
  idbAdapter = adapter;
}

export function resetIDBAdapter(): void {
  idbAdapter = null;
}

export async function ensureSchema(): Promise<void> {
  await getDb();
}

export async function getDb() {
  return openDB(DB_NAME, DB_VERSION, {
    upgrade(db) {
      if (!db.objectStoreNames.contains('profiles')) {
        db.createObjectStore('profiles', { keyPath: 'id' });
      }
      if (!db.objectStoreNames.contains('scanHistory')) {
        db.createObjectStore('scanHistory', { keyPath: 'id' });
      }
    },
  });
}

export async function dbPut<T>(storeName: string, value: T): Promise<void> {
  if (idbAdapter) {
    return idbAdapter.put(storeName, value);
  }
  const db = await getDb();
  await db.put(storeName, value);
}

export async function dbGet<T>(storeName: string, key: string): Promise<T | undefined> {
  if (idbAdapter) {
    return idbAdapter.get<T>(storeName, key);
  }
  const db = await getDb();
  return db.get(storeName, key);
}

export async function dbGetAll<T>(storeName: string): Promise<T[]> {
  if (idbAdapter) {
    return idbAdapter.getAll<T>(storeName);
  }
  const db = await getDb();
  return db.getAll(storeName);
}

export async function dbDelete(storeName: string, key: string): Promise<void> {
  if (idbAdapter) {
    return idbAdapter.delete(storeName, key);
  }
  const db = await getDb();
  await db.delete(storeName, key);
}

export async function dbClear(storeName: string): Promise<void> {
  if (idbAdapter) {
    return idbAdapter.clear(storeName);
  }
  const db = await getDb();
  await db.clear(storeName);
}
